import MFELink from '@components/MFELink/MFELink';
import AlertService from '@services/alert.service';
import { BoxIcon } from '@onsolve/onsolve-ui-components';
import React, { useEffect, useState } from 'react';
import styles from './AlertInbox.module.scss';
import configService from '@services/config.service';
import jwtService from '@services/jwt.service';
import PermissionService from '@services/permission.service';
export const AlertInbox = () => {
    const [count, setCount] = useState(0);
    const [hasLoadedCount, setHasLoadedCount] = useState(false);
    const { ControlCenterApiUrl } = configService;
    const { canViewAssetDataStore } = new PermissionService().permissions;
    const userId = canViewAssetDataStore() ? jwtService.getUserAssetId() : jwtService.getUserUuid();
    const alertService = new AlertService(ControlCenterApiUrl);
    const getRecievedAlertsCount = async () => {
        if (userId && !hasLoadedCount) {
            const result = await alertService.getReceivedAlertsCount(userId);
            setCount(result ?? 0);
            setHasLoadedCount(true);
        }
    };
    useEffect(() => {
        getRecievedAlertsCount();
    }, [userId, hasLoadedCount]);
    const alertsInboxUrl = '/alerts/inbox';
    return (<div className={styles.alertInbox} aria-label="AlertInbox">
            <MFELink target="_top" to={alertsInboxUrl} requiresJWT={false}>
                <BoxIcon size="lg" color="white"/>
                {count > 0 && (<span className={styles.badge} aria-label="AlertInboxBadge">
                        {count}
                    </span>)}
            </MFELink>
        </div>);
};
